import React, { useState, useEffect } from 'react'
import { Container, Table, Button, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../Components/Logo";
import LeadMapping from '../../Components/CRM/LeadMapping';
import Modal from "react-bootstrap/Modal";
import Files from "react-files";
import uploadImg from '../../assets/images/uploadfiles.png';
import uploadedFile from '../../assets/images/fileuploaded.png';
import { useAuth } from '../../Context/AuthContext';
import { postLeadExcel } from '../../Api/CRMAPI/rawleads';
import { toast } from "react-toastify";
import { useCRMDataContext } from '../../Context/CRMContext';

const LeadsList = () => {
    const { user } = useAuth();
    const { loadLeadSourceData, loadRawLeadData } = useCRMDataContext();
    const [loading, setLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [beffiles, setBefFiles] = useState({});
    const handleEdit = (item) => {

        setShowAddModal(true);
    };

    const onFilesChange = (files) => {
        console.log(files, 'files')
        setBefFiles(files[0]);
        const allimg = files.map((item) => URL.createObjectURL(item));
    };

    const onFilesError = (error, file) => {
        console.log("error code " + error.code + ": " + error.message);
    };

    const submitLeadExcel = async () => {
        try {
            const res = await postLeadExcel(beffiles, user.userId);
            if (res.status == 200) {
                toast.success(`🦄 Added Successfully`);
                loadRawLeadData();
                setBefFiles(null);
                setShowAddModal(false);
            }
        }
        catch (error) {
            toast.error(`🦄 Error : ${error.message}`);
        }
    }



    return (
        <>
            {/* <div className="main-content expand"> */}
                <Container fluid className="list-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Logo />
                        </div>
                    )}
                    <div className="lead-dashboard mt-4">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h4 className="fw-bold">
                                    🎯 Raw Lead Management
                                </h4>
                                <p className="text-muted">
                                    Capture, organize and convert raw leads into opportunities
                                </p>
                            </div>
                            <div>
                                <Button variant="outline-primary" className="me-2" onClick={() => {
                                    handleEdit();
                                }}>
                                    📥 Import Leads
                                </Button>
                                <Button className="btn-bulk me-2">
                                    ⚡ Bulk Actions
                                </Button>
                                <Button className="btn-assign me-2">
                                    👤 Assign Leads
                                </Button>
                                <Link to="/crm/create-raw-lead" className="btn btn-create">
                                    ➕ Create Lead
                                </Link>
                            </div>
                        </div>

                        {/* Stats Section */}
                        <div className="d-flex gap-3">
                            <div className="stat-card">
                                <h5 className="text-primary">0</h5>
                                <p className="text-muted">New Leads</p>
                            </div>
                            <div className="stat-card">
                                <h5 className="text-primary">0</h5>
                                <p className="text-muted">Contacted</p>
                            </div>
                            <div className="stat-card">
                                <h5 className="text-primary">0</h5>
                                <p className="text-muted">Qualified</p>
                            </div>
                            <div className="stat-card">
                                <h5 className="text-primary">0</h5>
                                <p className="text-muted">Converted</p>
                            </div>
                            <div className="stat-card">
                                <h5 className="text-primary">0</h5>
                                <p className="text-muted">Lost</p>
                            </div>
                        </div>
                    </div>

                    <LeadMapping />

                </Container>
            {/* </div> */}

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <div className="modelMain  modal-dialog-centered ">
                    <Modal.Body className="modelBody ">
                        <div className="m-2">
                            <Container>
                                <Row>
                                    <Col md={12}>
                                        {!beffiles?.id && (
                                            <>
                                                <h5>Upload Raw Leads</h5>
                                                <Files
                                                    className="files-dropzone"
                                                    onChange={onFilesChange}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".xlsx"
                                                    ]}

                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                    name="files"
                                                >
                                                    <img src={uploadImg} height="220" width={"100%"} />
                                                </Files>
                                            </>
                                        )}
                                        {beffiles?.id && (
                                            <>
                                                {/* <h5>Before Image</h5> */}
                                                <Files
                                                    className="files-dropzone d-flex"
                                                    onChange={onFilesChange}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".xlsx"
                                                    ]}

                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                >
                                                    <img src={uploadedFile} className='mx-auto' height="220" width={"50%"} />
                                                </Files>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="modelFooter justify-content-center">
                                        <button
                                            className="mainButton modelBtn bg-warning"
                                            variant="secondary"
                                            onClick={() => {
                                                setShowAddModal(false);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="mainButton modelBtn bg-success"
                                            variant="primary"
                                            onClick={submitLeadExcel}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Row>
                            </Container>
                        </div>
                    </Modal.Body>
                </div >
            </Modal >
        </>
    )
}

export default LeadsList